module.exports = __webpack_public_path__ + "static/media/washington-dc-6.31dcf672.jpg";